export const getTotalPercent = (statuses) => {
  return statuses && statuses.reduce((acc, status) => {
    return status.IsActive ? parseFloat(acc.toFixed(2)) + parseFloat(+status.Value) : acc;
  }, 0);
};
